'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _IDTextbox2 = require('../textbox/IDTextbox');

var _IDTextbox3 = _interopRequireDefault(_IDTextbox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDPercent = function (_IDTextbox) {
  (0, _inherits3.default)(IDPercent, _IDTextbox);

  function IDPercent(props) {
    (0, _classCallCheck3.default)(this, IDPercent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDPercent.__proto__ || (0, _getPrototypeOf2.default)(IDPercent)).call(this, props));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var type = _this.props.type;

      var value = type ? event.target.rawValue : event.target.value;
      _this.setValue(value);
    };

    _this.state = {
      isFocus: false,
      value: _this.convertValue(!_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue)
    };
    _this.dataTestID = 'percent';
    _this.inputType = 'percent';
    return _this;
  }

  (0, _createClass3.default)(IDPercent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.compareValue(nextProps.value)) {
        this.setState({
          value: this.convertValue(nextProps.value)
        });
      }
    }
  }, {
    key: 'convertValue',
    value: function convertValue(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      var _props = this.props,
          submitType = _props.submitType,
          numeralDecimalScale = _props.numeralDecimalScale;

      if (submitType === 1) {
        var newValue = _lodash2.default.round(value * 100, numeralDecimalScale || 2);
        return newValue < 100 ? newValue : 100;
      }
      return value;
    }
  }, {
    key: 'convertValueSubmit',
    value: function convertValueSubmit(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      var submitType = this.props.submitType;

      if (submitType === 1) {
        return _lodash2.default.round(value / 100, 4);
      }
      return value;
    }
  }, {
    key: 'setValue',
    value: function setValue(newValue) {
      var _this2 = this;

      if (newValue === "." || newValue === "-") {
        this.setState({ value: "0" }, function () {
          _this2.props.onChange && _this2.props.onChange(0);
        });
      } else if (newValue === "") {
        this.setState({ value: "" }, function () {
          _this2.props.onChange && _this2.props.onChange("");
        });
      } else if (parseFloat(newValue) > this.props.max) {
        this.state.rawCleave.setRawValue(100);
        if (this.state.value != 100) {
          this.setState({
            value: 100
          }, function () {
            _this2.props.onChange && _this2.props.onChange(_this2.convertValueSubmit(100));
          });
        }
      } else if (newValue != this.state.value) {
        this.setState({
          value: newValue || ''
        }, function () {
          _this2.props.onChange && _this2.props.onChange(_this2.convertValueSubmit(newValue));
        });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var value = this.state.value;

      return this.convertValueSubmit(value);
    }
  }]);
  return IDPercent;
}(_IDTextbox3.default);

exports.default = IDPercent;


IDPercent.defaultProps = (0, _extends3.default)({}, _IDTextbox3.default.defaultProps, {
  iconType: 'percentage',
  max: 100,
  submitType: 1,
  type: 'cleave',
  options: {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 4
  }
});